
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Carserviceinwardha() {



const cardData = {
  keyword: 'Car Rental Service in Wardha MIDC',
  heading: 'eTravo: Car Rental Service in Wardha MIDC',
  headingDescription: `eTravo proudly provides reliable and business-focused car rental services in Wardha MIDC, catering to the daily transport needs of employees, executives, and corporate guests in this key industrial hub. Our well-maintained fleet of air-conditioned, GPS-enabled vehicles ensures a smooth and professional ride for every journey—whether it’s routine staff commutes, executive travel, or corporate event transportation. With flexible rental durations, competitive pricing, and experienced drivers who understand industrial travel etiquette, eTravo delivers convenience and quality with every ride. Companies in Wardha MIDC choose us for our commitment to punctuality, safety, and round-the-clock customer support, making eTravo the preferred partner for smart corporate mobility.`,

  top: 'Top Places to visit in Wardha with eTravo',
     "topPlaces": [
    {
      "title": "Wardha MIDC Industrial Area",
      "description": "The Wardha MIDC Industrial Area hosts a variety of industries, including agro-processing units, textile manufacturing, and engineering firms. eTravo offers tailored transportation solutions to ensure timely and efficient employee commutes, supporting shift operations and enhancing industrial productivity."
    },
    {
      "title": "Hinganghat Industrial Zone",
      "description": "Hinganghat, located in Wardha district, is a prominent industrial hub known for its cotton and soybean processing units, as well as numerous small to medium-scale dal and oil mills. eTravo provides reliable cab services for employees and executives, facilitating smooth transportation to and from the industrial zone."
    },
    {
      "title": "Wardha City Center",
      "description": "The commercial and administrative heart of Wardha, featuring government offices, banks, and corporate establishments. eTravo's executive cab services facilitate seamless travel for business meetings and official engagements, ensuring punctuality and comfort."
    },
    {
      "title": "Wardha Junction Railway Station",
      "description": "A crucial railway hub connecting Wardha with major cities across India. eTravo offers convenient pickup and drop services, bridging the gap between rail travel and workplace commutes for employees and business travelers."
    },
    {
      "title": "Sevagram Railway Station",
      "description": "Serving the Sevagram town in Wardha district, this station is an important junction on the Howrah-Mumbai and Delhi-Chennai trunk lines. eTravo provides dependable cab services for passengers and employees commuting to and from the station."
    },
    {
      "title": "Nagpur-Wardha National Mega Logistics Hub",
      "description": "A significant infrastructure project aimed at enhancing the region's warehousing and transportation capabilities. eTravo supports logistics personnel with scheduled and on-demand cab services, ensuring smooth operations and timely deliveries."
    },
    {
      "title": "Datta Meghe Institute of Higher Education and Research",
      "description": "A premier educational institution attracting students and faculty from various regions. eTravo offers reliable transportation solutions for daily commutes, academic events, and inter-campus travel, promoting educational excellence."
    },
    {
      "title": "Wardha Retail and Shopping Centers",
      "description": "Facilitating transportation for employees and customers to and from major retail outlets and shopping centers in Wardha. eTravo's services enhance the shopping experience by providing convenient and safe travel options."
    },
    {
      "title": "Wardha Hospitality Sector",
      "description": "Providing transportation solutions for hotel staff and guests, ensuring seamless travel experiences within the hospitality industry. eTravo's services contribute to guest satisfaction and operational efficiency."
    },
    {
      "title": "Wardha Healthcare Facilities",
      "description": "Offering reliable cab services for healthcare professionals and patients, ensuring timely arrivals and departures from hospitals and clinics. eTravo's services are integral to the region's healthcare accessibility."
    }
  ],

services: [
  {
    name: 'Wardha MIDC Corporate Car Rentals',
    description: `Customized corporate car rental solutions tailored to businesses operating in Wardha MIDC. We offer flexible rental durations to suit daily commute needs, site visits, or special corporate events, supported by a fleet of well-maintained vehicles and seamless booking processes for uninterrupted business travel.`
  },
  {
    name: 'Employee Car Service Wardha MIDC',
    description: `Reliable employee transportation synchronized with factory and office shift timings in Wardha MIDC. Our GPS-enabled vehicles and professional drivers ensure safe, timely, and comfortable journeys for your workforce, enhancing daily operational efficiency.`
  },
  {
    name: 'Business Car Rentals Wardha MIDC',
    description: `Flexible and prompt car rental services for business owners, corporate staff, and executives traveling within Wardha and nearby regions. Drivers with local expertise guarantee efficient routing and comfortable rides tailored to meet your business requirements.`
  },
  {
    name: 'Corporate Staff Car Hire Wardha MIDC',
    description: `Group transport solutions designed for corporate teams, offering multi-route planning and GPS tracking to ensure cost-effectiveness and employee safety. This service reduces traffic congestion while promoting punctual, coordinated commutes.`
  },
  {
    name: 'Reliable Corporate Car Service Wardha MIDC',
    description: `Our commitment to reliability is reflected in our clean, well-serviced cars and courteous, professional drivers. We focus on punctuality, transparent communication, and customized solutions to meet the unique needs of corporate clients in Wardha MIDC.`
  },
  {
    name: 'AC Corporate Cars Wardha MIDC',
    description: `Comfort-focused air-conditioned car services to provide a pleasant travel experience regardless of Wardha’s weather conditions. Ideal for daily commuting and executive transport, ensuring a cool, relaxed journey during peak summer and humid seasons.`
  },
  {
    name: 'Staff Pickup and Drop Car Wardha MIDC',
    description: `Comprehensive staff pickup and drop services supporting multiple shifts, including night duties, with flexible scheduling and 24/7 availability. Experienced drivers ensure safe, punctual transport for your employees at all hours.`
  },
  {
    name: 'Affordable Business Car Rentals Wardha MIDC',
    description: `Cost-effective car rental options tailored for small and medium enterprises as well as large corporations. Transparent pricing and scalable vehicle deployment allow businesses to optimize transport expenses without compromising service quality.`
  },
  {
    name: 'Executive Car Services Wardha MIDC',
    description: `Premium executive transportation featuring luxury vehicles and trained chauffeurs, perfect for airport transfers, important business meetings, and client hospitality. We provide discreet, comfortable, and professional travel experiences for senior management and VIP guests.`
  },
  {
    name: 'Monthly Corporate Car Rentals Wardha MIDC',
    description: `Simplified monthly rental plans with fixed routes that ease employee transportation management and reduce administrative workload. These plans offer consistent service quality, convenient billing, and close coordination with HR and admin teams for hassle-free operations.`
  },
  {
    name: 'Industrial Area Employee Transport Wardha MIDC',
    description: `Specialized employee transport services for factories and industrial units in Wardha MIDC, focusing on punctuality, safety, and compliance with industrial standards. Our optimized routing supports smooth and timely travel for all shifts.`
  },
  {
    name: 'Corporate Client Cars Wardha MIDC',
    description: `Dedicated client transportation services ensuring visiting business guests experience punctual, comfortable, and professional travel. From airport pickups to facility tours, our polished vehicles and trained drivers create a positive impression for your corporate image.`
  },
  {
    name: 'Business Meeting Car Rentals Wardha MIDC',
    description: `Fast-response car rental services tailored for executives attending urgent meetings within Wardha and surrounding areas. Easy booking, prompt dispatch, and skilled drivers ensure timely arrivals and seamless business travel.`
  },
  {
    name: 'Wardha Industrial Area Car Hire',
    description: `Flexible on-demand car hire services across Wardha’s industrial zones for site visits, logistics, and corporate errands. Our knowledgeable drivers understand local industrial routes and traffic, providing efficient and hassle-free transportation.`
  },
  {
    name: 'Corporate Shuttle Car Rentals Wardha MIDC',
    description: `Group shuttle services using minibuses or large vans for bulk employee transport during shift changes or corporate events. This service enhances operational efficiency, reduces environmental impact, and ensures coordinated employee travel.`
  }
],

tableData: [
  ['Wardha MIDC Corporate Car Rentals', 'Employee Car Service Wardha MIDC'],
  ['Business Car Rentals Wardha MIDC', 'Corporate Staff Car Hire Wardha MIDC'],
  ['Reliable Corporate Car Service Wardha MIDC', 'AC Corporate Cars Wardha MIDC'],
  ['Staff Pickup and Drop Car Wardha MIDC', 'Affordable Business Car Rentals Wardha MIDC'],
  ['Executive Car Services Wardha MIDC', 'Monthly Corporate Car Rentals Wardha MIDC'],
  ['Industrial Area Employee Transport Wardha MIDC', 'Corporate Client Cars Wardha MIDC'],
  ['Business Meeting Car Rentals Wardha MIDC', 'Wardha Industrial Area Car Hire'],
  ['Corporate Shuttle Car Rentals Wardha MIDC', '']
],


"whychoose": [
  {
    "WhyChooseheading": "Customized Car Rental Services for Wardha MIDC",
    "WhyChoosedescription": "eTravo offers tailored car rental solutions for businesses in Wardha MIDC, supporting efficient employee transportation and flexible travel options to meet diverse corporate needs in this industrial region."
  },
  {
    "WhyChooseheading": "Wide Selection of Vehicles to Match Your Requirements",
    "WhyChoosedescription": "Our extensive fleet includes sedans, SUVs, and multi-utility vehicles, allowing your business to select the ideal vehicle for daily commutes, client visits, or executive travel, all maintained to high safety and comfort standards."
  },
  {
    "WhyChooseheading": "Professional Drivers with In-Depth Local Knowledge",
    "WhyChoosedescription": "Our experienced drivers possess detailed knowledge of Wardha MIDC’s geography and traffic patterns, ensuring timely, safe, and courteous transportation services for your workforce."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans Aligned with Business Shifts",
    "WhyChoosedescription": "Understanding the varied shift timings in industrial setups, we offer adaptable rental plans including hourly, daily, and long-term options to suit your company’s operational schedule."
  },
  {
    "WhyChooseheading": "Real-Time GPS Tracking for Enhanced Security",
    "WhyChoosedescription": "All rental vehicles are equipped with GPS tracking systems, allowing real-time monitoring to ensure passenger safety and improve operational transparency."
  },
  {
    "WhyChooseheading": "Clear and Transparent Billing",
    "WhyChoosedescription": "We provide detailed invoices with clear breakdowns of rental charges and trip details, making financial management straightforward and hassle-free for corporate clients."
  },
  {
    "WhyChooseheading": "Strict Safety and Hygiene Protocols",
    "WhyChoosedescription": "Our vehicles undergo regular cleaning and maintenance, and drivers follow strict hygiene practices to guarantee a safe and healthy travel environment."
  },
  {
    "WhyChooseheading": "Dedicated Account Management for Seamless Service",
    "WhyChoosedescription": "Each corporate client receives personalized support from a dedicated account manager who handles bookings, addresses concerns, and ensures a smooth rental experience in Wardha MIDC."
  }
]






}

const faqData = [
  [
    {
      question: "Which areas do your Wardha MIDC car rental services cover?",
      answer: "Our car rental services span across Wardha MIDC and nearby industrial clusters, offering reliable transportation for business and employee use."
    },
    {
      question: "Can we rent cars on a daily, weekly, or monthly basis?",
      answer: "Yes, we provide flexible rental plans—daily, weekly, or monthly—based on your operational and workforce needs."
    },
    {
      question: "Is monthly invoicing available for corporate rentals?",
      answer: "Yes, we offer consolidated monthly billing with detailed trip and rental reports to simplify your accounting process."
    },
    {
      question: "Are your drivers experienced with local industrial routes?",
      answer: "Absolutely. Our drivers are well-trained, route-aware, and maintain high standards of safety and professionalism."
    },
    {
      question: "What safety measures are followed for rented vehicles?",
      answer: "We implement vehicle sanitization, GPS tracking, routine inspections, and provide trained drivers for maximum safety."
    },
    {
      question: "Do you provide dedicated corporate support?",
      answer: "Yes, we assign account managers for corporate clients and offer quick-response support for bookings, issues, and adjustments."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Ashok Kale",
    designation: "Logistics Head, Wardha Engineering Pvt. Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s rental service is professional and punctual. It has helped us reduce delays and streamline staff transportation.”"
  },
  {
    name: "Ms. Deepali Naik",
    designation: "Admin Manager, Wardha BioTech",
    rating: [1, 1, 1, 1, 1],
    text: "“Reliable vehicles, courteous drivers, and excellent support—eTravo has become our trusted partner for employee travel in Wardha MIDC.”"
  }
];






































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Car Rental Service in Wardha MIDC",
  "image": "https://www.etravo.in/images/keyword/car-rental-wardha-midc.jpg",
  "description": "Reliable corporate car rental service in Wardha MIDC offering employee transport, business rentals, industrial area cars, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/car-rental-wardha-midc"
  }
};







    return (
        <div>
<Helmet>
  <title>Car Rental Service in Wardha MIDC | Corporate & Industrial Car Rentals | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate car rental service in Wardha MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cars available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/86.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Carserviceinwardha;